import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import conf from '../conf/conf';
const basePort = window.location.port ? `:${window.location.port}/` : '/';
const baseSlug = (conf.basename !== '' ? `${conf.basename}/` : '').replace('//', '/');
const baseUrl = `${window.location.protocol}//${window.location.hostname}${basePort}${baseSlug}`;
const userManagerConfig = {
    client_id: conf.clientId,
    redirect_uri: `${baseUrl}callback`,
    response_type: 'code',
    scope: 'openid profile CompuAccess HelpDoc IdtSrvMngr offline_access',
    authority: conf.identityPath,
    post_logout_redirect_uri: `${baseUrl}login`,
    filterProtocolClaims: true,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.localStorage })
};
const userManager = new UserManager(userManagerConfig);
export default userManager;
